import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import locales_es from "../../locales/es";
import {HREF_PAGE_BILLING, hrefLogin, PLAN_TAGS} from "../../models/constants";
import Subheader from "../../components/subheader";
import Spinner from "../../components/spinner";
import FreePlan from "./components/freePlan";
import CreateCert from "./components/createCert";
import Navigation from "./components/navigation";
import APIService from "../../modules/apiService";
import {SubscriptionPlanContext} from "../../context/SubscriptionPlanContext";
import AuthService from "../../modules/authService";

const api = new APIService();

export const BillingContext = createContext(null);
export const useBillingContext = () => useContext(BillingContext);

export default function BillingPage({showMainModal}) {
  const auth = new AuthService();
  const [billingSettingsIsLoading, setBillingSettingsIsLoading] = useState(true);
  const [billingSettings, setBillingSettings] = useState(null);
  const {
    subscriptionPlan,
    loading: subscriptionPlanIsLoading,
    error: subscriptionPlanError
  } = useContext(SubscriptionPlanContext);
  const userHasFreePlan = useMemo(() => subscriptionPlan?.tag === PLAN_TAGS.FREE, [subscriptionPlan]);

  const showErrorModal = (message) => showMainModal("Error", message);

  const fetchBillingSettings = async () => {
    setBillingSettingsIsLoading(true);

    try {
      const response = await api.getMyBillingSettings();

      if (response.ok) {
        const { data } = await response.json();
        setBillingSettings(data);
      }
    } catch (err) {
      console.error(err);
      showErrorModal(`Error al obtener la configuración de facturación: ${err.message}`);
    }

    setBillingSettingsIsLoading(false);
  };

  useEffect(() => {
    if (subscriptionPlan) {
      fetchBillingSettings();
    }
  }, [subscriptionPlan]);

  useEffect(() => {
    if (subscriptionPlanError) {
      showErrorModal(subscriptionPlanError);
    }
  }, [subscriptionPlanError]);

  useEffect(() => {
    const checkUserStatus = () => {
      const isLoggedIn = auth.isLoggedUser();
      if (!isLoggedIn) {
        window.location.href = hrefLogin;
      }
    };

    checkUserStatus();
  });

  return (
    <BillingContext.Provider
      value={{
        showErrorModal,
        setBillingSettings,
        billingSettings,
        fetchBillingSettings,
      }}
    >
      <Subheader
        breadcrumbs={[
          {
            name: locales_es.billing,
            href: HREF_PAGE_BILLING,
          },
        ]}
      />
      <div className="kt-portlet p-3">
          {subscriptionPlanIsLoading || billingSettingsIsLoading ? <Spinner/> : userHasFreePlan ?
            <FreePlan showMainModal={showMainModal}/> : billingSettings ? <Navigation {...billingSettings} /> : <CreateCert/>}
      </div>
    </BillingContext.Provider>
  );
}
